module.exports = __webpack_public_path__ + "img/capture.43ea028f.png";